const SELECTOR = '.c-content-1998_inner';
const CARD_SELECTOR = '[class*="c-musegroup-content-1998_card_"]';
const DOT_SELECTOR = '.c-content-1998_slider-item';
const YEAR_SELECTOR = '.c-content-1998_year';
const ACTIVE_CLASS = 'activ';
const INTERVAL = 3000;
const PAUSE_AFTER_CLICK = 5000;
const YEARS = [1998, 2001, 2006, 2018, 2025];

export class CardSlider {
  static init() {
    const container = document.querySelector(SELECTOR);
    if (!container) return;

    this.container = container;
    this.cards = [...container.querySelectorAll(CARD_SELECTOR)];
    this.dots = [...document.querySelectorAll(DOT_SELECTOR)];
    this.yearEl = document.querySelector(YEAR_SELECTOR);
    this.current = 0;
    this.animating = false;

    if (this.cards.length < 2) return;

    // Set initial state
    this.cards.forEach((card, i) => {
      if (i !== 0) {
        card.style.transform = 'translateY(100%)';
      }
      card.style.transition = 'transform 1600ms cubic-bezier(0.16, 1, 0.3, 1)';
      card.style.zIndex = i === 0 ? 10 : 1;
    });

    this.bindDots();
    this.updateDots();
    this.start();
  }

  static bindDots() {
    // Ensure the dots container is above the cards
    const dotsParent = this.dots[0]?.parentElement;
    if (dotsParent) {
      dotsParent.style.zIndex = '20';
      dotsParent.style.pointerEvents = 'auto';
    }

    this.dots.forEach((dot, i) => {
      dot.style.cursor = 'pointer';
      dot.style.pointerEvents = 'auto';
      dot.addEventListener('click', () => {
        if (this.animating || i === this.current) return;
        this.destroy();
        this.goTo(i);
        this.pauseTimer = setTimeout(() => this.start(), PAUSE_AFTER_CLICK);
      });
    });
  }

  static start() {
    this.timer = setInterval(() => this.next(), INTERVAL);
  }

  static next() {
    const nextIndex = (this.current + 1) % this.cards.length;
    this.goTo(nextIndex);
  }

  static goTo(index) {
    if (this.animating || index === this.current) return;
    this.animating = true;

    const oldCard = this.cards[this.current];
    const newCard = this.cards[index];

    // New card enters from below, old card exits upward
    newCard.style.transition = 'none';
    newCard.style.transform = 'translateY(100%)';
    newCard.style.zIndex = 11;
    oldCard.style.zIndex = 10;

    newCard.offsetHeight;

    newCard.style.transition = 'transform 1600ms cubic-bezier(0.16, 1, 0.3, 1)';
    newCard.style.transform = 'translateY(0)';

    oldCard.style.transition = 'transform 1600ms cubic-bezier(0.16, 1, 0.3, 1)';
    oldCard.style.transform = 'translateY(100%)';

    this.current = index;
    this.updateDots();
    this.updateYear();

    setTimeout(() => {
      // Reset old card below, ready for next cycle
      oldCard.style.transition = 'none';
      oldCard.style.transform = 'translateY(100%)';
      oldCard.style.zIndex = 1;
      newCard.style.zIndex = 10;
      this.animating = false;
    }, 1650);
  }

  static destroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    if (this.pauseTimer) {
      clearTimeout(this.pauseTimer);
      this.pauseTimer = null;
    }
  }

  static updateYear() {
    if (this.yearEl && YEARS[this.current] != null) {
      this.yearEl.textContent = YEARS[this.current];
    }
  }

  static updateDots() {
    this.dots.forEach((dot, i) => {
      if (i === this.current) {
        dot.classList.add(ACTIVE_CLASS);
      } else {
        dot.classList.remove(ACTIVE_CLASS);
      }
    });
  }
}
